var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6885,
    cy: 42.6884,
    rx: 18.6885,
    ry: 19.3115,
    fill: "#BB91F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6281 42.8787H20.0408C19.6332 42.8787 19.2423 42.7113 18.9541 42.4135C18.6658 42.1157 18.5039 41.7117 18.5039 41.2905V32.4169C18.5032 32.2107 18.5419 32.0064 18.6177 31.8156C18.6935 31.6249 18.805 31.4514 18.9458 31.3053L41.9991 7.48354C42.1421 7.33349 42.3125 7.21433 42.5005 7.13299C42.6885 7.05165 42.8903 7.00977 43.0941 7.00977C43.2979 7.00977 43.4997 7.05165 43.6877 7.13299C43.8756 7.21433 44.0461 7.33349 44.1891 7.48354L52.7572 16.3373C52.9025 16.4851 53.0178 16.6612 53.0965 16.8555C53.1752 17.0497 53.2157 17.2582 53.2157 17.4688C53.2157 17.6794 53.1752 17.8879 53.0965 18.0822C53.0178 18.2764 52.9025 18.4526 52.7572 18.6003L29.704 42.4221C29.5625 42.5675 29.3947 42.6827 29.2101 42.7611C29.0255 42.8394 28.8277 42.8794 28.6281 42.8787Z",
    stroke: "#413D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9465 12.7051L47.7047 23.8219",
    stroke: "#413D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS23);
export default __webpack_public_path__ + "static/media/s2-3.450fc738b402dec770dab61e0e698dd0.svg";
export { ForwardRef as ReactComponent };